import { CheckboxInput } from '@framework/form/inputs/CheckboxInput.tsx';
import { RowElement } from '@framework/ui/components/row/RowElement.tsx';
import { Space, Tooltip } from 'antd';
import { ConfigFormItem } from '../../../../../ui/form/ConfigFormItem.tsx';
import { type IWidgetComponentProps } from '../../../IWidgetType.ts';
import { getWidgetProps } from '../../inputs/common/util/getWidgetProps.ts';
import { PaymentRowFieldPreview } from './components/PaymentRowFieldPreview.tsx';
import { PaymentRowReportField } from './components/PaymentRowReportField.tsx';
import { PaymentRowWidgetContainer } from './components/PaymentRowWidgetContainer.tsx';
import { type IPaymentRowWidget } from './IPaymentRowWidget.ts';

export interface IPaymentRowWidgetPreviewComponentProps
  extends IWidgetComponentProps<IPaymentRowWidget> {}

export function PaymentRowWidgetPreviewComponent(
  props: IPaymentRowWidgetPreviewComponentProps,
) {
  const { widget } = props;
  const options = getWidgetProps(props);

  return (
    <PaymentRowWidgetContainer
      included
      canBeExcluded={widget.canBeExcluded}
      left={
        <Tooltip title="Includi nel pagamento">
          <ConfigFormItem
            name={`${options.name}@included`}
            widget={props.widget}
          >
            <CheckboxInput name={`${options.name}@included`} />
          </ConfigFormItem>
        </Tooltip>
      }
      report={
        widget.showReport && (
          <Space size={0} wrap>
            <PaymentRowReportField
              readonly={true}
              name={options.name}
              label={'Importo Unitario'}
              value={null}
              widget={widget}
            />
            <PaymentRowReportField
              readonly={true}
              name={options.name}
              label={'Imponibile'}
              value={null}
              widget={widget}
            />
            <PaymentRowReportField
              readonly={true}
              name={options.name}
              label={'IVA'}
              value={null}
              widget={widget}
            />
            <PaymentRowReportField
              readonly={true}
              name={options.name}
              label={'Totale'}
              value={null}
              widget={widget}
            />
          </Space>
        )
      }
    >
      <PaymentRowFieldPreview
        config={widget.description}
        options={options}
        label={'Descrizione'}
        widget={widget}
      />
      <RowElement>
        <PaymentRowReportField
          readonly={true}
          name={options.name}
          label={'Importo Listino'}
          value={null}
          widget={widget}
        />
        <PaymentRowFieldPreview
          config={widget.quantity}
          options={options}
          label={'Quantità'}
          widget={widget}
        />
        <PaymentRowFieldPreview
          config={widget.unit}
          options={options}
          label={'Unità di Misura'}
          widget={widget}
        />
        <PaymentRowFieldPreview
          config={widget.vat}
          options={options}
          label={'IVA'}
          widget={widget}
        />
        <PaymentRowFieldPreview
          config={widget.discount}
          options={options}
          label={'Sconto/Esenzione'}
          widget={widget}
        />
      </RowElement>
      <Space>
        {/* {widget.canBeExcluded && (
          <Tooltip title="Includi nel pagamento">
            <ConfigFormItem name={`${options.name}@included`}>
              <CheckboxInput name={`${options.name}@included`} />
            </ConfigFormItem>
          </Tooltip>
        )} */}
        {/* {widget.showReport && (
          <Space size={0}>
            <PaymentRowReportField
              readonly={true}
              name={options.name}
              label={'Imponibile'}
              value={null}
            />
            <PaymentRowReportField
              readonly={true}
              name={options.name}
              label={'IVA'}
              value={null}
            />
            <PaymentRowReportField
              readonly={true}
              name={options.name}
              label={'Totale'}
              value={null}
            />
          </Space>
        )} */}
      </Space>
    </PaymentRowWidgetContainer>
  );
}
